import DayGridScenario from '../schema/DayGridScenario';
import { action } from 'satcheljs';

export const createDayGridScenario = action(
    'createDayGridScenario',
    (scenario: DayGridScenario) => ({
        scenario,
    })
);
